var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar"},[_c('hamburger',{staticClass:"hamburger-container",attrs:{"toggle-click":_vm.toggleSideBar,"is-active":_vm.sidebar.opened}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }